var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { typography, space, layout, flexbox } from 'styled-system';
import styled from 'styled-components';
var StyledText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n  cursor: ", ";\n  word-break: normal;\n  word-wrap: break-word;\n"], ["\n  display: inline-flex;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n  cursor: ", ";\n  word-break: normal;\n  word-wrap: break-word;\n"])), typography, space, layout, flexbox, function (props) { return props.level ? props.theme.textLevel[props.level] : ''; }, function (props) { return props.color ? props.theme.palette[props.color] : 'inherit'; }, function (props) { return props.pointer ? 'pointer' : ''; });
var SFText = function (_a) {
    var _b = _a.pointer, pointer = _b === void 0 ? false : _b, props = __rest(_a, ["pointer"]);
    return (_jsx(StyledText, __assign({}, props, { pointer: pointer }, { children: props.children })));
};
export default SFText;
var templateObject_1;
